import { Box, Loader, Typography } from "@braintrust/braintrust-ui-components";

import {
  EmployerInfo,
  EmployerMessage,
  OfferDetails,
  TalentNavigation,
  TalentOfferChecklist,
  TalentTopStripeContent,
} from "../../components";
import { BoilerplatePendingOfferTermsSection } from "../../components/boilerplate-offer-terms-section";
import {
  AdditionalInfo,
  AdditionalTerms,
  CommitmentDetails,
} from "../../components/offer-preview-sections";
import { EquipmentShippingAddressFields } from "../../forms";
import { AcceptOfferFormInstance } from "../../forms/accept-offer-form";
import { useTalentOffer } from "../../hooks";
import { OfferLayout, OfferPreviewContentLayout } from "../../layout";

export const TalentPreviewOfferPage = () => {
  const {
    job,
    offer,
    loading,
    employer,
    onOfferReject,
    onSubmit,
    onSubmitFail,
    initialValues,
  } = useTalentOffer();

  if (loading || !offer || !job || !employer) {
    return (
      <OfferLayout navigationSocket={null}>
        <Loader centered />
      </OfferLayout>
    );
  }

  const displayOfferChecklist = shouldShowTalentOfferChecklist(offer.status);

  return (
    <AcceptOfferFormInstance
      initialValues={initialValues}
      onSubmit={onSubmit}
      onSubmitFail={onSubmitFail}
      hideError
    >
      <OfferLayout
        topStripeSocket={<TalentTopStripeContent offer={offer} />}
        navigationSocket={
          <TalentNavigation offer={offer} onOfferReject={onOfferReject} />
        }
      >
        <OfferPreviewContentLayout
          leftSocket={
            <>
              <EmployerInfo
                jobId={job.id}
                employer={employer}
                sx={{ padding: "24px 32px !important" }}
              />
              <EmployerMessage offer={offer} />
            </>
          }
          rightSocket={
            <>
              <OfferDetails showUpdatedLabel={true} offer={offer} job={job} />
              <CommitmentDetails offer={offer} />
              <AdditionalTerms offer={offer} />
              <AdditionalInfo
                offer={offer}
                bottomSocket={
                  offer.talent_has_own_equipment ? null : (
                    <Box>
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: { xs: "column", sm: "row" },
                          alignItems: { xs: "flex-start", sm: "center" },
                        }}
                      >
                        <Typography
                          component="p"
                          variant="label"
                          size="large"
                          sx={{ mt: 4, mb: { xs: 0, sm: 3 } }}
                        >
                          Equipment shipping address
                        </Typography>
                        <Typography
                          component="p"
                          size="small"
                          color="grey"
                          sx={{
                            mb: { xs: 2, sm: 0 },
                            ml: { xs: 0, sm: 2 },
                            mt: { xs: 0, sm: 1.4 },
                          }}
                        >
                          Required
                        </Typography>
                      </Box>
                      <EquipmentShippingAddressFields
                        disableAll={
                          offer.status !== ENUMS.OfferStatus.NEW &&
                          offer.status !== ENUMS.OfferStatus.UPDATED
                        }
                      />
                    </Box>
                  )
                }
              />
              {displayOfferChecklist && <TalentOfferChecklist offer={offer} />}
              <BoilerplatePendingOfferTermsSection offer={offer} />
            </>
          }
        />
      </OfferLayout>
    </AcceptOfferFormInstance>
  );
};

const shouldShowTalentOfferChecklist = (
  status: EnumType<typeof ENUMS.OfferStatus>,
) => {
  if (
    status === ENUMS.OfferStatus.ACCEPTED ||
    status === ENUMS.OfferStatus.EXTENDED
  ) {
    return true;
  }

  return false;
};
